/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/**
 * Imprt CSS.
 */
import "swiper/css/bundle";

/**
 * 共通スライダー
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const defaultSlider = () => {
	if (window.matchMedia("(min-width: 600px)").matches) {
		var centeredSlides = "false";
	} else {
		var centeredSlides = "ture";
	}

	const option = {
		loop: true,
		slidesPerView: "auto",
		initialSlide: 0,
		centeredSlides: centeredSlides,
		preventClicks: true,
		speed: 2000,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false,
		},
		navigation: {
			prevEl: ".button.--prev",
			nextEl: ".button.--next",
		},
	};

	const slider = new Swiper(".post-slider", option);
};

const fadeSlider = () => {
	/**
	 * Setting - Fade Slider - デフォルト
	 */
	const option = {
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		loopAdditionalSlides: 1,
		speed: 1000,
		autoplay: {
			delay: 6000,
			disableOnInteraction: false,
			waitForTransition: false,
		},
		followFinger: false,
	};

	/**
	 * Action - Fade Slider - デフォルト
	 */
	const slider = new Swiper(".slider-fade", option);
};

const thumbnaiSlider = () => {
	const hasPShareSliderClass = document.querySelector(".p-thumbnail-slider");

	if (hasPShareSliderClass) {
		/**
		 * Setting - Thumbnail Slider
		 */
		const optionThumbail = {
			slidesPerView: 4,
			spaceBetween: 10,
			grabCursor: true,
			breakpoints: {
				761: {
					slidesPerView: 9,
					spaceBetween: 10,
				},
			},
		};

		const sliderThumbnail = new Swiper(".slider__thumbnail", optionThumbail);

		/**
		 * Setting - Main Slider
		 */
		const optionMain = {
			// effect: "fade",
			// fadeEffect: {
			// 	crossFade: true,
			// },
			speed: 1000,
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			// navigation: {
			// 	nextEl: ".swiper-button-next",
			// 	prevEl: ".swiper-button-prev",
			// },
			thumbs: {
				swiper: sliderThumbnail,
			},
		};

		const sliderThumbnailMain = new Swiper(".slider__thumbnail__main", optionMain);
	}
};

const calendarSlider = () => {
	/**
	 * Setting - calendar Slider - デフォルト
	 */
	const option = {
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		// loop: true,
		loopAdditionalSlides: 1,
		speed: 1000,
		// autoplay: {
		// 	delay: 6000,
		// 	disableOnInteraction: false,
		// 	waitForTransition: false,
		// },
		followFinger: false,
		navigation: {
			nextEl: ".calendar__arrow.--next",
			prevEl: ".calendar__arrow.--prev",
		},
	};

	/**
	 * Action - calendar Slider - デフォルト
	 */
	const slider = new Swiper(".slider-calendar", option);
};

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/*index: mv home */

const mvSlider = () => {
	const option = {
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		loopAdditionalSlides: 1,
		speed: 1000,
		autoplay: {
			delay: 6000,
			disableOnInteraction: false,
			waitForTransition: false,
		},
		followFinger: false,
	};
	const slider = new Swiper(".mv-slider", option);

	//#mvがある場合
	// if (document.getElementById("mv")) {
	// 	const element = document.getElementById("mv");
	// 	document.addEventListener("DOMContentLoaded", function () {
	// 		if (sessionStorage.getItem("splashDisplayed")) {
	// 			document.getElementById("splash").style.display = "none";
	// 			element.classList.remove("paused");
	// 			return;
	// 		}
	// 		slider.autoplay.stop();

	// 		const lottiePlayer = document.getElementById("lottie");
	// 		lottiePlayer.addEventListener("complete", function () {
	// 			document.getElementById("splash").classList.add("hidden");
	// 			slider.autoplay.start();
	// 			element.classList.remove("paused");
	// 			sessionStorage.setItem("splashDisplayed", "true");
	// 		});
	// 	});
	// }
};

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/*index: insta slider */

const instaSlider = () => {
	const swiper = new Swiper(".insta-list", {
		loop: true, // ループ有効
		slidesPerView: 6, // 一度に表示する枚数
		speed: 6000, // ループの時間
		allowTouchMove: false, // スワイプ無効
		autoplay: {
			delay: 0, // 途切れなくループ
		},
	});
};

const carouselSlider = () => {
	/**
	 * Setting - Carousel Slider - デフォルト
	 */
	const option = {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		speed: 1500,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		breakpoints: {
			// スライドの表示枚数：000px以上の場合
			760: {
				slidesPerView: 2,
				spaceBetween: 0,
			},
			1441: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
		},
		navigation: {
			nextEl: ".slider-button-next",
			prevEl: ".slider-button-prev",
		},
	};

	/**
	 * Action - Carousel Slider - デフォルト
	 */
	const sliderCarousel = new Swiper(".slider-carousel", option);
};

const setSlider = () => {
	// defaultSlider();
	mvSlider();
	calendarSlider();
	fadeSlider();
	thumbnaiSlider();
	carouselSlider();
	// instaSlider();
};
export { setSlider };
